// src/components/APropos.tsx
import React, { useState } from 'react';
import './APropos.css';
import aproposImage from '../Images/portrait.png';

interface AProposProps {
    language: 'en' | 'fr';
}

const APropos: React.FC<AProposProps> = ({ language }) => {
    const [expanded, setExpanded] = useState(false);
    const handleToggle = () => setExpanded(!expanded);

    // Définition des textes pour chaque langue
    const texts = {
        en: {
            title: 'About me',
            paragraph1:
                "My name is Julien Araujo Da Silva and I am currently a second-year student in the BUT Computer Science program at IUT Clermont-Auvergne.",
            paragraph2:
                "My main strengths include perseverance, reliability, attentiveness, and autonomy.",
            expandedParagraph1:
                "Passionate about technology, I invest in developing my programming skills and tackling technical challenges.",
            expandedParagraph2:
                "I am seeking an apprenticeship to apply my knowledge and contribute to innovative projects.",
            buttonReadMore: "Read more",
            buttonReadLess: "Show less",
        },
        fr: {
            title: 'A propos de moi',
            paragraph1:
                "Je m'appelle Julien Araujo Da Silva et je suis actuellement étudiant en deuxième année de BUT Informatique à l'IUT Clermont-Auvergne.",
            paragraph2:
                "Mes qualités principales incluent la persévérance, la fiabilité, l'attention et l'autonomie.",
            expandedParagraph1:
                "Passionné par la technologie, je m'investis dans le développement de mes compétences en programmation et dans la résolution de défis techniques.",
            expandedParagraph2:
                "Je recherche une alternance afin de mettre en pratique mes connaissances et contribuer à des projets innovants.",
            buttonReadMore: "Lire plus",
            buttonReadLess: "Réduire",
        },
    };

    const {
        title,
        paragraph1,
        paragraph2,
        expandedParagraph1,
        expandedParagraph2,
        buttonReadMore,
        buttonReadLess,
    } = texts[language];

    return (
        <section className="a-propos-container">
            <h2 className="a-propos-title">{title}</h2>
            <div className="a-propos-content">
                {/* Colonne gauche : image */}
                <div className="a-propos-image">
                    <img src={aproposImage} alt="Illustration A propos de moi" />
                </div>
                {/* Colonne droite : texte */}
                <div className="a-propos-text">
                    <p>{paragraph1}</p>
                    <p>{paragraph2}</p>
                    {expanded && (
                        <>
                            <p>{expandedParagraph1}</p>
                            <p>{expandedParagraph2}</p>
                        </>
                    )}
                    <button className="toggle-button" onClick={handleToggle}>
                        {expanded ? buttonReadLess : buttonReadMore}
                    </button>
                </div>
            </div>
        </section>
    );
};

export default APropos;
